<template>
    <div>
        <h3>{{ JSONParseTranslations(area.title, locale.key) }}</h3>
        <q-btn
            class="plus-btn"
            icon="add"
            text-color="primary"
            size="26px"
            flat
            dense
            :to="{
                name: 'Courses',
                params: {
                    areaId: area.id,
                },
            }"
        ></q-btn>
    </div>
</template>

<script>
import translate from '@/local-shared/mixins/translate'
import store from '@/store'

export default {
    name: 'AreaThumb',

    mixins: [translate],

    props: {
        area: {
            type: Object,
            default: () => { },
        },
    },

    data() {
        return {
        }
    },

    computed: {
        locale() {
            return store.getters['locale/currentLocale']
        }
    },

    async created() {
    },

    methods: {
    },
}
</script>
